import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Location } from "vue-router";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import AudioPlayer from "@/lib/audioPlayer";
import { $t } from "@/lib/i18nHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";
import AvatarDescription from "@/components/AvatarDescription";
import BaseButton from "@/components/BaseButton";
import BaseCloser from "@/components/BaseCloser";
import BaseIcon from "@/components/BaseIcon";

@Component({ name: "CallNotification", components: { AvatarDescription, BaseButton, BaseIcon, BaseCloser } })
export default class CallNotification extends Vue {
  @Prop({ required: true })
  public readonly opponentUser!: UserPublicData;

  @Prop({ type: String })
  public readonly opponentSubscriptionStatus!: "follower" | "subscriber" | "user";

  public loading = false;

  public declineHandler() {
    this.loading = true;
    this.$emit("decline");
  }

  public get description() {
    if (this.opponentSubscriptionStatus !== "user") return $t("Your {0}", [$t(this.opponentSubscriptionStatus)]);
    return "";
  }

  public get userProfileUrl(): Location {
    return getProfileUrl(this.opponentUser);
  }

  public created() {
    AudioPlayer.play("ring", { loop: true });
  }

  public beforeDestroy() {
    AudioPlayer.stop("ring");
  }
}
